
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embedded-menu/[cName]/brands",
      function () {
        return require("private-next-pages/embedded-menu/[cName]/brands/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embedded-menu/[cName]/brands"])
      });
    }
  